import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { ROLES } from '@auth/authRoles';

const EquipmentForecast = lazy(() => import('./EquipmentForecast'));

const EquipmentForecastRoute: FuseRouteItemType = {
	path: '/equipment-forecast',
	auth: [ROLES.Admin, ROLES.HR, ROLES.Manager, ROLES.RentalManager, ROLES.AreaManager],
	element: <EquipmentForecast />
};

export default EquipmentForecastRoute;
